import { histogram } from "@/lib/science/plot-stats";
import { SCI_PALETTE } from "@/lib/science/sci-chart";
import { cartesianAxis, PlotShell } from "@/lib/science/sci-plot";
import { m } from "@/paraglide/messages";

const EXAMPLE = "4\n5\n5\n6\n6\n6\n6\n7\n7\n7\n8\n8\n9\n5\n6\n7\n6\n5\n7\n8";

export function HistogramPlot() {
  return (
    <PlotShell
      toolId="histogram"
      inputLabel={m.plot_input_label()}
      placeholder={m.hist_placeholder()}
      example={EXAMPLE}
      exampleLabel={m.plot_load_example()}
      hint={m.plot_hint_empty()}
      buildOption={(data, theme) => {
        const h = histogram(data.flat);
        return {
          tooltip: { trigger: "axis" },
          grid: { left: 48, right: 20, top: 20, bottom: 48 },
          xAxis: {
            type: "category",
            data: h.labels,
            axisLabel: {
              color: theme.muted,
              fontSize: 9,
              rotate: h.labels.length > 8 ? 45 : 0,
            },
            axisLine: { lineStyle: { color: theme.border } },
          },
          yAxis: { type: "value", ...cartesianAxis(theme) },
          series: [
            {
              type: "bar",
              data: h.counts,
              barCategoryGap: "2%",
              itemStyle: { color: SCI_PALETTE[0] },
            },
          ],
        };
      }}
    />
  );
}
